"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractEnd = exports.contractStart = exports.availableDate = exports.getDeadline = void 0;
const tender_box_1 = require("./tender-box");
function getDeadline(timeline) {
    var _a;
    return (0, tender_box_1.getDate)((0, tender_box_1.getField)((0, tender_box_1.getFirstBox)((_a = timeline.deadline) !== null && _a !== void 0 ? _a : undefined), 0));
}
exports.getDeadline = getDeadline;
function availableDate(timeline) {
    var _a;
    return (0, tender_box_1.getDate)((0, tender_box_1.getField)((_a = timeline.availableDate) !== null && _a !== void 0 ? _a : undefined, 0));
}
exports.availableDate = availableDate;
function contractStart(timeline) {
    var _a;
    return (0, tender_box_1.getDate)((0, tender_box_1.getField)((_a = timeline.contractStartAndEndStart) !== null && _a !== void 0 ? _a : undefined, 0));
}
exports.contractStart = contractStart;
function contractEnd(timeline) {
    var _a;
    return (0, tender_box_1.getDate)((0, tender_box_1.getField)((_a = timeline.contractStartAndEndEnd) !== null && _a !== void 0 ? _a : undefined, 0));
}
exports.contractEnd = contractEnd;
